// extracted by mini-css-extract-plugin
module.exports = {"container":"GameOver_container__2y-k6","gameover":"GameOver_gameover__2HdXh","message":"GameOver_message__19sQ3"};